import React from 'react';
import ReactGA from 'react-ga';
import FeaturedProjectShowcase from '../../components/featuredProjectShowcase/featuredProjectShowcase';
import ScrollToTopButton from '../../components/scrollToTopButton/ScrollToTopButton';
import style from './portfolioPage.module.scss';

export default function PortfolioPage() {
  ReactGA.pageview(window.location.pathname + window.location.search);

  React.useEffect(()=> {
    window.scrollTo({top: 0})
  },[])

  return (
    <main className={style.portfolioContainer}>
      <FeaturedProjectShowcase sectionAriaLabel="Portfolio projects" />
      <ScrollToTopButton />
    </main>
  )
}
